<template>
  <div id="app" class="body_wrapper">
    <!-- header_area geo_font navbar_fixed terms -->
    <header
      class="header_area geo_font"
      v-bind:class="
        FixedMenu
          ? 'navbar_fixed ' + $route.name
          : $route.name != 'HomePage'
          ? 'navbar_fixed'
          : $route.name
      "
    >
      <nav class="navbar navbar-expand-lg menu_one menu_four">
        <div class="container">
          <a
            class="navbar-brand sticky_logo"
            href="/"
            v-on:click="ScrollPage('Top')"
          >
            <img
              src="@/assets/img/Fertimo/logo_fertimo_fill_500_100_w.png"
              width="200"
              alt="Fertimo"
            />
            <img
              src="@/assets/img/Fertimo/logo_fertimo_fill_500_100.png"
              width="200"
              alt="Fertimo"
            />
          </a>

          <button
            class="navbar-toggler"
            v-bind:class="MobileMenu ? '' : 'collapsed'"
            type="button"
            v-on:click="MobileMenu = !MobileMenu"
          >
            <span class="menu_toggle">
              <span class="hamburger">
                <span></span>
                <span></span>
                <span></span>
              </span>
              <span class="hamburger-cross">
                <span></span>
                <span></span>
              </span>
            </span>
          </button>

          <div
            class="navbar-collapse justify-content-end collapse geo_font"
            v-bind:class="MobileMenu ? 'show fade' : ''"
            id="navbarSupportedContent"
          >
            <!-- Navigation -->
            <ul class="navbar-nav navbar-nav menu w_menu ml-auto">
              <li class="nav-item dropdown submenu">
                <a
                  href="javascript:void(0)"
                  class="nav-link dropdown-toggle geo_font"
                  v-on:click="ScrollPage('WhyFertimo')"
                  >{{ Lang("Why Fertimo") }}</a
                >
              </li>
              <li class="nav-item dropdown submenu">
                <a
                  href="javascript:void(0)"
                  class="nav-link dropdown-toggle geo_font"
                  v-on:click="ScrollPage('HowItWorks')"
                  >{{ Lang("How it works") }}</a
                >
              </li>
              <li class="nav-item dropdown submenu">
                <a
                  href="javascript:void(0)"
                  class="nav-link dropdown-toggle geo_font"
                  v-on:click="ScrollPage('Modules')"
                  >{{ Lang("Modules") }}</a
                >
              </li>
              <li class="nav-item dropdown submenu">
                <a
                  href="javascript:void(0)"
                  class="nav-link dropdown-toggle geo_font"
                  v-on:click="ScrollPage('Pricing')"
                  >{{ Lang("Pricing") }}</a
                >
              </li>
              <li class="nav-item dropdown submenu">
                <a
                  href="javascript:void(0)"
                  class="nav-link dropdown-toggle geo_font"
                  v-on:click="ScrollPage('Businesses')"
                  >{{ Lang("Businesses") }}</a
                >
              </li>
            </ul>
            <!-- [./ End] Navigation -->

            <!-- Login button -->
            <!--  <div class="btn-group geo_font w_color f_400 f_size_18 l_height30 wow fadeInUp geo_font" v-bind:class="MobileMenu ? 'ml-4' : 'ml-5'" data-wow-delay="0.6s">
                            <a href="http://platform.fertimo.com/" target="_blank" v-bind:class="$store.state.Tmp.LangID == 42 ? 'geo_font' : ''" class="security_btn btn_hover">{{ Lang('Log in') }}</a>
                            <a href="javascript:void(0)" v-on:click="OpenPreOrder" v-bind:class="$store.state.Tmp.LangID == 42 ? 'geo_font' : ''" class="security_btn btn_hover ml-2">{{ Lang('Sign up') }}</a>
                        </div> -->
            <!-- [./ ENd] Login button -->
            <div class="main-login-btn ml-5">
              <a
                href="https://platform.fertimo.com/"
                target="_blank"
                class="btn security_btn btn_hover"
              >
                <i class="fas fa-sign-in-alt"></i>
              </a>
              <a
                href="javascript:void(0)"
                v-on:click="OpenPreOrder"
                class="btn security_btn btn_hover"
                data-toggle="modal"
                data-target=".register"
              >
                <i class="fas fa-user"></i>
              </a>
            </div>

            <!-- Languages -->
            <div v-if="IsMobile">
              <!-- Button trigger modal -->
              <div class="mt-2 languages" style="margin-left: 0px;">
                <a
                  data-toggle="modal"
                  data-target="#LanguageModal"
                  class="nav-link geo_font pl-1"
                  href="javascript:void(0)"
                >
                  <!-- {{ Lang('ChooseLanguage') }}  -->
                  <i
                    class="fas fa-language"
                    style="font-size: 20px;padding-top: 4px;float: left;margin-right: 10px;margin-left: 3px;"
                  ></i>
                  {{
                    Object.values($store.state.Cache.Languages).filter(
                      x => x.id == $store.state.Tmp.LangID
                    )[0].title
                  }}
                </a>
              </div>
              <!-- Modal -->
              <div
                class="modal fade full-modal"
                id="LanguageModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="LanguageModalModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        {{ Lang("ChooseLanguage") }}
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body" style="text-align: center;">
                      <a
                        v-for="item in $store.state.Cache.Languages"
                        :key="item.id"
                        v-on:click="SetLang(item.id)"
                        class="er_btn er_btn_two er_btn_two_w mr-2"
                        href="javascript:void(0)"
                      >
                        {{ item.title }}
                      </a>
                    </div>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      ref="CloseLanguageModal"
                      style="display:none;"
                      data-dismiss="modal"
                    ></button>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else
              class="dropdown mt-2 languages"
              style="margin-left: 30px;"
            >
              <!-- btn_get btn_hover -->
              <a
                class="lang_btn btn_hover dropdown-toggle"
                href="javascript:void(0)"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{
                  Object.values($store.state.Cache.Languages).filter(
                    x => x.id == $store.state.Tmp.LangID
                  )[0].title
                }}
              </a>
              <div class="dropdown-menu lang_menu" aria-labelledby="Languages">
                <a
                  v-for="item in $store.state.Cache.Languages"
                  :key="item.id"
                  v-on:click="SetLang(item.id)"
                  class="dropdown-item"
                  href="javascript:void(0)"
                >
                  {{ item.title }}
                </a>
              </div>
            </div>
            <!-- [./ End] Languages -->
          </div>
        </div>
      </nav>
    </header>

    <router-view />
  </div>
</template>
<style>
.modal-backdrop.show {
  display: none;
}
</style>

<script>
// import $ from 'jquery'
import Vue from "vue";
import Langs from "@/mixins/Lang.js";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import "./assets/vendors/sckroller/jquery.parallax-scroll.js";
import "./assets/vendors/owl-carousel/owl.carousel.min.js";
// import './assets/vendors/imagesloaded/imagesloaded.pkgd.min.js'
// import './assets/vendors/isotope/isotope-min.js'

import "./assets/vendors/magnify-pop/jquery.magnific-popup.min.js";
import "./assets/vendors/counterup/jquery.counterup.min.js";
import "./assets/vendors/counterup/jquery.waypoints.min.js";
import "./assets/vendors/counterup/appear.js";
import "./assets/vendors/circle-progress/circle-progress.js";
import "./assets/vendors/scroll/jquery.mCustomScrollbar.concat.min.js";
import "./assets/js/plugins.js";
import "./assets/js/main.js";

var SocialSharing = require("vue-social-sharing");
Vue.use(SocialSharing);

export default {
  name: "App",
  mixins: [Langs],
  data: function() {
    return {
      FixedMenu: false,
      MobileMenu: false,
      Session: {
        LangID: this.$store.state.Tmp.LangID
      },
      IsMobile: false
    };
  },

  mounted: function() {
    this.GetSY();
    window.addEventListener("scroll", this.GetSY);
    // Update LangID in session
    Vue.set(this.Session, "LangID", this.$store.state.Tmp.LangID);
    VueCookies.set("Session", JSON.parse(JSON.stringify(this.Session)));

    let check = false;
    (function(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    if (check) Vue.set(this, "IsMobile", true);
  },

  methods: {
    GetSY: function() {
      this.FixedMenu = false;
      if (window.scrollY > 50) this.FixedMenu = true;
    },

    SetLang: function(LangID) {
      this.$store.commit("SetState", {
        key: "Tmp.LangID",
        val: parseInt(LangID)
      });
      // Update LangID in session
      Vue.set(this.Session, "LangID", parseInt(LangID));
      VueCookies.set("Session", JSON.parse(JSON.stringify(this.Session)));

      if (this.$refs.CloseLanguageModal != undefined && this.IsMobile == true)
        this.$refs.CloseLanguageModal.click();
    }, // [./ End] SetLang()

    OpenPreOrder: function() {
      for (var i in this.$children) {
        if (this.$children[i].ID == "Home") this.$children[i].OpenPreOrder();
      }
    },

    ScrollPage: function(Page) {
      var element = document.getElementById(Page);
      var top = element.offsetTop - 100;
      window.scrollTo(0, top);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue